import type { ReactNode } from 'react';
import React, { createContext, useContext, useMemo, useState } from 'react';

interface StickyBarContextProps {
  isApplePayVisible: boolean;
  setIsApplePayVisible: (isVisible: boolean) => void;
}

const StickyBarContext = createContext<StickyBarContextProps | undefined>(
  undefined,
);

export const StickyBarProvider = ({ children }: { children: ReactNode }) => {
  const [isApplePayVisible, setIsApplePayVisible] = useState(false);

  const value = useMemo(
    () => ({ isApplePayVisible, setIsApplePayVisible }),
    [isApplePayVisible],
  );

  return (
    <StickyBarContext.Provider value={value}>
      {children}
    </StickyBarContext.Provider>
  );
};

export const useStickyBarContext = () => {
  const context = useContext(StickyBarContext);
  if (context === undefined) {
    throw new Error(
      'useStickyBarContext must be used within a StickyBarProvider',
    );
  }
  return context;
};
